import React from 'react';
import {View, Text} from 'react-native';
import PropTypes from 'prop-types';
import styles from '../../../style/adminTools';
import useLayoutTier from './useLayoutTier';

const SectionHeader = ({
  title,
  label,
  description,
  chip,
  right,
  band = 'customer',
  testID
}) => {
  const phone = useLayoutTier() === 'mobile';
  if (label) {
    return (
      <Text style={styles.sectionSubLabel} testID={testID}>
        {label}
      </Text>
    );
  }
  const team = band === 'team';
  return (
    <View style={styles.sectionHeader} testID={testID}>
      <View style={styles.sectionHeaderTitleRow}>
        <View style={styles.sectionHeaderText}>
          <Text
            style={[
              styles.sectionTitle,
              phone ? styles.sectionTitlePhone : null
            ]}
            testID={testID ? `${testID}-title` : undefined}
          >
            {title}
          </Text>
        </View>
        {chip ? (
          <View
            style={[
              styles.sectionChip,
              team ? styles.sectionChipTeam : styles.sectionChipCustomer
            ]}
            testID={testID ? `${testID}-chip` : undefined}
          >
            <Text
              style={[
                styles.sectionChipText,
                team
                  ? styles.sectionChipTextTeam
                  : styles.sectionChipTextCustomer
              ]}
              testID={testID ? `${testID}-chip-text` : undefined}
            >
              {chip}
            </Text>
          </View>
        ) : null}
        {right || null}
      </View>
      {description ? (
        <Text style={styles.sectionDescription}>{description}</Text>
      ) : null}
    </View>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  chip: PropTypes.string,
  right: PropTypes.node,
  band: PropTypes.oneOf(['team', 'customer']),
  testID: PropTypes.string
};

export default SectionHeader;
